import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'descricaoReduzidaPipe',
  standalone: false,
})
export class DescricaoReduzidaPipe implements PipeTransform {
  transform(texto: string, tamanho: number): string {
    if (texto.length > tamanho) {
      return texto.substring(0, tamanho) + '... ';
    }

    return texto;
  }
}
